import { Component, Prop, Vue } from "vue-property-decorator";
import { store } from "@/main";
import * as types from "@/store/constants/index_types";
@Component
class VipRetain extends Vue {
  @Prop()
  private ctx: any;

  public render() {
    return (
      <img
        style="width:144px;height:144px;margin:0 auto;"
        src={require("@/assets/icons-file/vip/paymentVipAddLikes.png")}
        alt=""
      />
    );
  }
}

export default VipRetain;
